<template>
    <el-dialog custom-class="dialogForm" class="measDialog" :visible.sync="visible" :before-close="handleClose" :close-on-click-modal="false" width="80%" :title="title">
        <el-scrollbar class="dialogContentScroll">
            <el-form :hide-required-asterisk="disabled" :model="form" ref="form" :rules="rules">
                <div class="formItemBox mb-15">
                    <el-form-item label="考试名称" prop="examname">
                        <el-input :disabled="disabled" v-model="form.examname"  show-word-limit placeholder="请输入" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="考试时长（分钟）" prop="examlength">
                        <el-input :disabled="disabled" v-model="form.examlength"  show-word-limit placeholder="请输入" clearable></el-input>
                    </el-form-item>
                </div>
                <div class="formItemBox mb-15">
                    <el-form-item label="考试开始时间" prop="starttime">
                        <el-date-picker
                            value-format="yyyy-MM-dd HH:mm:ss"
                            v-model="form.starttime"
                            type="datetime"
                            :disabled="disabled"
                            placeholder="选择日期">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="考试结束时间" prop="endtime">
                        <el-date-picker
                            value-format="yyyy-MM-dd HH:mm:ss"
                            v-model="form.endtime"
                            :disabled="disabled"
                            type="datetime"
                            placeholder="选择日期">
                        </el-date-picker>
                    </el-form-item>
                </div>
                <div class="formItemBox mb-15">
                    <el-form-item label="可参与次数" prop="maxjoincount">
                        <el-input :disabled="disabled" v-model="form.maxjoincount"  show-word-limit placeholder="请输入" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="最低过关分数" prop="minscore">
                        <el-input :disabled="disabled" v-model="form.minscore"  show-word-limit placeholder="请输入" clearable></el-input>
                    </el-form-item>
                </div>
                <div class="formItemBox mb-15">
                    <el-form-item label="对应题库" prop="resource.name">
                        <el-select :disabled="disabled" v-model="form.resource.name" @change="getClassCOde" placeholder="请选择">
                            <el-option
                            v-for="item in options"
                            :key="item.code"
                            :label="item.name"
                            :value="item.name">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="参与学员" prop="joinstudenttype">
                        <el-select :disabled="disabled" v-model="form.joinstudenttype" @change="getClassCOde" placeholder="请选择">
                            <el-option
                            v-for="item in studentsType"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                        
                    </el-form-item>
                </div>
                <div class="formItemBox mb-15" v-if="form.joinstudenttype == 2 || form.joinstudenttype == 3">
                    <el-form-item label="学员选择" prop="joinstudentlist">
                        <div class="selectBox">
                            <div class="ipt" :class="disabled?'isDetail':''">
                                <el-tag
                                    v-for="tag in studentsList"
                                    @close="delTag(tag)"
                                    :key="tag.name"
                                    :closable="!disabled"
                                    >
                                    {{tag.name}}
                                </el-tag>
                            </div>
                            <div v-if="!disabled" @click="handleOpenSelectStu" class="btn">添加</div>
                        </div>
                        <!-- <el-input v-model="form.periodcount" maxlength="20" show-word-limit placeholder="请输入" clearable></el-input> -->
                    </el-form-item>
                </div>
                <div v-if="!disabled" class="formItemBox mb-15">
                    <el-form-item label="说明" prop="memo">
                        <el-input v-model="form.memo" type="textarea" show-word-limit placeholder="请输入" clearable></el-input>
                    </el-form-item>
                </div>
                <div v-else>
                    <div class="formItemBox mb-15">
                        <el-form-item label="参与考试次数" >
                            <el-input :disabled="disabled" v-model="form.maxjoincount"  show-word-limit clearable></el-input>
                        </el-form-item>
                        <el-form-item label="完成考试次数" >
                            <el-input :disabled="disabled" v-model="detailInfo.totalfinishcount"  show-word-limit clearable></el-input>
                        </el-form-item>
                    </div>
                    <div class="formItemBox mb-15">
                        <el-form-item label="考试过关次数" >
                            <el-input :disabled="disabled" v-model="detailInfo.totalpasscount" show-word-limit clearable></el-input>
                        </el-form-item>
                        <el-form-item label="过关率" >
                            <el-input :disabled="disabled" v-model="detailInfo.passrate"  show-word-limit clearable></el-input>
                        </el-form-item>
                    </div>
                </div>
            </el-form>
        </el-scrollbar>
        <div v-if="!disabled" slot="footer" style="text-align:right">
            <el-button @click="closeDialog('form')">取 消</el-button>
            <el-button type="primary" :loading="isLoading" @click="saveClass('form')">确定</el-button>
        </div>
        <div v-else slot="footer" style="text-align:right">
            <el-button @click="closeDialog('form')">取 消</el-button>
            <el-button type="primary" :loading="isLoading" @click="changeStatus">编辑</el-button>
        </div>
        <SelectStu @getStuData="getStuData" ref="selectStu" />
    </el-dialog>
</template>
<script>
import {saveCourseExamConfig, getQuesBankListBySelect,getCourseExamConfigDetail} from '@/api/measApi/teachManagement.js'
import {getTableDefaultPageSize} from '@/assets/measAssets/js/tools.js'
import SelectStu from './selectStudents.vue'
export default {
    data(){
        return {
            form: {
                classcoursecode: this.$route.query.code,
                code: this.$route.query.classCode,
                endtime: '',
                examlength: '',
                examname: '',
                joinstudentlist: [],
                joinstudenttype: '',
                maxjoincount: '',
                memo: '',
                minscore: '',
                resource: {
                    code: '',
                    name: ''
                },
                starttime: ''
            },
            detailInfo: {
                totalfinishcount: '',
                totalpasscount: '',
                passrate: ''
            },
            disabled: false,
            qsBank: {
                condition: {

                },
                page: 1,
                pagesize: getTableDefaultPageSize()
            },
            options: [

            ],
            studentsType: [
                {label: '全部学员', value: 1},
                {label: '未通过学员', value: 2},
                {label: '自定义学员', value: 3},
            ],
            rules: {
                examname: [
                    { required: true, message: '考试名称', trigger: 'blur' }
                ],
                examlength: [
                    { required: true, message: '课时时长', trigger: 'blur' }
                ],
                starttime: [
                    { required: true, message: '开始时间', trigger: 'blur' }
                ],
                endtime: [
                    { required: true, message: '结束时间', trigger: 'blur' }
                ],
                maxjoincount: [
                    { required: true, message: '可参与次数', trigger: 'blur' }
                ],
                minscore: [
                    { required: true, message: '最低过关分数', trigger: 'blur' }
                ],
                'resource.name': [
                    { required: true, message: '对应题库', trigger: 'blur' }
                ],
                joinstudenttype: [
                    { required: true, message: '参与学员', trigger: 'blur' }
                ],
                joinstudentlist: [
                    { required: true, message: '选择学员' }
                ]
            },
            visible: false,
            title: '',
            isLoading: false,
            detailParams: {
                code: ''
            },
            studentsList: [
            ],
            disabled: false
        }
    },
    components: {
        SelectStu
    },
    methods: {
        init(code, disabled){//disabled是否是详情
            if(disabled){
                this.disabled = disabled
                this.title = '详情'
            }else{
                this.disabled = false
                this.title = code ? "编辑": '新增'
            }
            this.studentsList = []
            this.form.code = code || ''
            this.detailParams.code = code || ''
            this.visible = true
            this.getQuesBankListBySelect()
            if(code){
                // this.disabled = true
                this.getCourseExamConfigDetail()
            }
        },
        // 获取题库下拉数据
        getQuesBankListBySelect(){
            getQuesBankListBySelect(this.qsBank).then(res => {
                this.options = res.data
            })
        },
        getStuData(info){
            this.studentsList = info
            this.form.joinstudentlist = []
            this.studentsList.forEach(item => {
                this.form.joinstudentlist.push({
                    code: item.studentcode,
                    name: item.name
                })  
            })
        },
        delTag(tag){
            tag.isCheck = false
            this.studentsList = this.studentsList.filter(item => {
                return item.isCheck
            })
            let arr = []
            this.studentsList.forEach(item => {
                arr.push({
                    code: item.studentcode,
                    name: item.name
                })  
            })
            this.form.joinstudentlist = JSON.parse(JSON.stringify(arr))
            
        },
        handleClose(){
            this.visible = false
            this.disabled = false
            this.studentsList = []
            this.$refs['form'].resetFields()
        },
        closeDialog(formName){
            this.visible = false
            this.$refs[formName].resetFields()
        },
        getClassCOde(name){
            this.options.map(item => {
                if(item.name === name){
                    this.form.resource.code = item.code
                    return true
                }
            })
            console.log(this.form)
        },
        changeStatus(){
            this.disabled = false
            this.title = '详情'
            // this.init()
        },
        // 打开选择学员弹窗
        handleOpenSelectStu(){
            console.log(this.$route.query,'this.formthis.form')
            this.$refs.selectStu.init(this.studentsList, this.$route.query.code, this.$route.query.classCode, this.form.joinstudenttype)
        },
        // 获取课程详情
        getCourseExamConfigDetail(){
            getCourseExamConfigDetail(this.detailParams).then(res => {
                console.log(res,'课程详情')
                // this.form = res.data
                this.form.joinstudenttype = res.data.jointype
                this.form.code = res.data.code
                this.form.endtime = res.data.endtime
                this.form.examlength = res.data.examlength
                this.form.examname = res.data.examname
                this.form.maxjoincount = res.data.maxjoincount
                this.form.memo = res.data.memo
                this.form.minscore = res.data.minscore
                this.form.minscore = res.data.minscore
                this.form.resource = res.data.resource
                this.form.starttime = res.data.starttime
                let arr = res.data.joinstudentlist ? JSON.parse(JSON.stringify(res.data.joinstudentlist)) : []
                arr.forEach(item => {
                    this.studentsList.push({
                        name: item.name,
                        studentcode: item.code,
                        isCheck: true
                    })
                })
                this.detailInfo.totalfinishcount = res.data.totalfinishcount
                this.detailInfo.totalpasscount = res.data.totalpasscount
                this.detailInfo.passrate = res.data.passrate
                this.form.joinstudentlist = res.data.joinstudentlist
                // this.form.begindate = res.data.begindate
                // this.form.enddate = res.data.begindate
                // this.form.courseconfigcode = res.data.code
                // this.form.courseconfigname = res.data.name
                // this.form.memo = res.data.memo
                // this.form.name = res.data.name
                // this.form.periodcount = res.data.periodcount
                // this.form.score = res.data.score

                console.log(this.studentsList,'详情')
            })
        },
        saveClass(formName){
            console.log(this.form,'form')
            // return
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.isLoading = true
                    this.saveCourseExamConfig(formName)
                } else {
                    return false;
                }
            });
        },
        saveCourseExamConfig(formName){
            saveCourseExamConfig(this.form).then(res => {
                this.isLoading = false
               if(res.code == '000'){
                  this.$message.success(res.msg)
                  this.visible = false
                  this.$refs[formName].resetFields()
                  this.$parent.init()
               }else{
                    this.$message.error(res.msg)
               }
            })
        }
    }
}
</script>
<style lang="scss" scoped>
::v-deep .el-tag{
    height: 26px;
    font-size: 12px;
    line-height: 26px;
    margin-right: 10px;
}
.isDetail{
    background: #F5F7FA!important;
}
.formItemBox{
    .selectBox{
        display: flex;
        width: 100%;

        .ipt{
            flex: 1;
             padding: 0 20px;
             box-sizing: border-box;
            height: 36px;
            background: #FFFFFF;
            border: 1px solid #DFE6EC;
        }
        .btn{
            width: 64px;
            height: 36px;
            background: #EFF4FF;
            border-radius: 0px 4px 4px 0px;
            border: 1px solid #DFE6EC;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 12px;
            color: #5792FF;
            box-sizing: border-box;
        }
    }
}
</style>